import * as Types from '../Constants/AllConstants';

// Single credential reducer (not paginated)
export const GetPagedPaynowCredentialsReducer = (
  state = { credentials: null },
  action
) => {
  switch (action.type) {
    case Types.PAYNOW_CREDENTIALS_PAGED_REQUEST:
      return { loading: true };
    case Types.PAYNOW_CREDENTIALS_PAGED_SUCCESS:
      return {
        loading: false,
        credentials: action.payload, // Single object, not .content
      };
    case Types.PAYNOW_CREDENTIALS_PAGED_FAIL:
      return { loading: false, error: action.payload };
    case Types.PAYNOW_CREDENTIALS_RESET:
      return { credentials: null };
    default:
      return state;
  }
};

export const CreatePaynowCredentialReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAYNOW_CREDENTIAL_CREATE_REQUEST:
      return { loading: true };
    case Types.PAYNOW_CREDENTIAL_CREATE_SUCCESS:
      return { loading: false, success: true, credential: action.payload };
    case Types.PAYNOW_CREDENTIAL_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PAYNOW_CREDENTIAL_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const UpdatePaynowCredentialReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAYNOW_CREDENTIAL_UPDATE_REQUEST:
      return { loading: true };
    case Types.PAYNOW_CREDENTIAL_UPDATE_SUCCESS:
      return { loading: false, success: true, credential: action.payload };
    case Types.PAYNOW_CREDENTIAL_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PAYNOW_CREDENTIAL_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const DeletePaynowCredentialReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAYNOW_CREDENTIAL_DELETE_REQUEST:
      return { loading: true };
    case Types.PAYNOW_CREDENTIAL_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PAYNOW_CREDENTIAL_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PAYNOW_CREDENTIAL_DELETE_RESET:
      return {};
    default:
      return state;
  }
};